import { useCallback, useEffect, useState } from 'react';

export const useChatPromptField = (initialValue: string) => {
  const [fieldValue, setFieldValue] = useState(initialValue || '');

  useEffect(() => {
    setFieldValue(initialValue || '');
  }, [initialValue]);

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(event.target.value);
  }, []);

  return { fieldValue, handleChange, setFieldValue };
};
